import React from 'react';
import { motion } from 'framer-motion';
import { Calendar, MapPin, Clock, X, Heart, CalendarPlus, Share2 } from 'lucide-react';
import { FacebookShareButton, TwitterShareButton, WhatsappShareButton, LinkedinShareButton, FacebookIcon, TwitterIcon, WhatsappIcon, LinkedinIcon } from 'react-share';

const EventModal = ({ event, onClose, isFavorite, onToggleFavorite, onAddToCalendar }) => {
    const formatEventDate = (dateString) => {
        if (!dateString) return { date: '', time: '' };
        const date = new Date(dateString);
        return {
            date: date.toLocaleDateString("tr-TR", { day: "numeric", month: "long", year: "numeric" }),
            time: date.toLocaleTimeString("tr-TR", { hour: "2-digit", minute: "2-digit" })
        };
    };
    
    const isUpcoming = (dateString) => new Date(dateString) > new Date();
    
    const eventDate = formatEventDate(event.event_date);
    const upcoming = isUpcoming(event.event_date);
    const shareUrl = window.location.href;

    return (
        <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50 p-4"
            onClick={onClose}
        >
            <motion.div
                initial={{ scale: 0.9, y: 20 }}
                animate={{ scale: 1, y: 0 }}
                exit={{ scale: 0.9, y: 20 }}
                className="relative max-w-3xl w-full max-h-[90vh] bg-white dark:bg-gray-800 rounded-2xl shadow-2xl flex flex-col"
                onClick={(e) => e.stopPropagation()}
            >
                <div className="relative rounded-t-2xl overflow-hidden">
                    <img
                        src={event.image ? (event.image.startsWith('http') ? event.image : `http://localhost:8000${event.image}`) : '/placeholder-image.jpg'}
                        alt={event.title}
                        className="w-full max-h-[60vh] object-contain bg-gray-100 cursor-pointer hover:opacity-90 transition-opacity"
                        onClick={() => window.open(event.image ? (event.image.startsWith('http') ? event.image : `http://localhost:8000${event.image}`) : '/placeholder-image.jpg', '_blank')}
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent pointer-events-none" />
                    
                    <button onClick={onClose} className="absolute top-4 right-4 bg-black/30 text-white p-2 rounded-full hover:bg-black/50 transition-all z-10">
                        <X size={24} />
                    </button>

                    <div className="absolute bottom-0 left-0 p-6 text-white">
                        <h1 className="text-3xl font-bold mb-1">{event.title}</h1>
                        <div className="flex items-center text-white/90">
                            <Calendar size={16} className="mr-2" />
                            {eventDate.date} - {eventDate.time}
                        </div>
                    </div>
                </div>

                <div className="p-6 overflow-y-auto flex-grow">
                    <div className="flex flex-wrap gap-3 mb-6">
                        <button
                            onClick={() => onToggleFavorite(event.id)}
                            className={`flex items-center gap-2 px-4 py-2 rounded-lg transition-all text-sm font-semibold ${
                                isFavorite 
                                    ? 'bg-red-100 text-red-600' 
                                    : 'bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-200 hover:bg-gray-200 dark:hover:bg-gray-600'
                            }`}
                        >
                            <Heart size={16} fill={isFavorite ? 'currentColor' : 'none'} />
                            {isFavorite ? 'Favorilerden Çıkar' : 'Favorilere Ekle'}
                        </button>
                        
                        <button
                            onClick={() => onAddToCalendar(event)}
                            className="flex items-center gap-2 px-4 py-2 rounded-lg transition-all bg-blue-100 text-blue-600 hover:bg-blue-200 text-sm font-semibold"
                        >
                            <CalendarPlus size={16} />
                            Takvime Ekle
                        </button>
                    </div>

                    {event.description && (
                        <div className="mb-6">
                            <h3 className="text-lg font-semibold mb-2 text-gray-800 dark:text-gray-100">Açıklama</h3>
                            <p className="leading-relaxed text-gray-600 dark:text-gray-300 whitespace-pre-wrap">{event.description}</p>
                        </div>
                    )}

                    {event.location && (
                        <div className="mb-6">
                            <h3 className="text-lg font-semibold mb-2 text-gray-800 dark:text-gray-100">Konum</h3>
                            <div className="flex items-center text-gray-600 dark:text-gray-300">
                                <MapPin size={16} className="mr-2 text-blue-500" />
                                {event.location}
                            </div>
                        </div>
                    )}
                </div>

                <div className="p-6 border-t border-gray-100 dark:border-gray-700">
                    <h3 className="text-lg font-semibold mb-3 text-gray-800 dark:text-gray-100">Bu Etkinliği Paylaş</h3>
                    <div className="flex flex-wrap gap-3">
                        <FacebookShareButton url={shareUrl} quote={event.title}>
                            <FacebookIcon size={32} round />
                        </FacebookShareButton>
                        <TwitterShareButton url={shareUrl} title={event.title}>
                            <TwitterIcon size={32} round />
                        </TwitterShareButton>
                        <WhatsappShareButton url={shareUrl} title={event.title}>
                            <WhatsappIcon size={32} round />
                        </WhatsappShareButton>
                        <LinkedinShareButton url={shareUrl} title={event.title}>
                            <LinkedinIcon size={32} round />
                        </LinkedinShareButton>
                    </div>
                </div>
            </motion.div>
        </motion.div>
    );
};

export default EventModal; 